import dayjs from 'dayjs'
import { t } from 'i18next'
import { Chart } from 'primereact/chart'
import React, { useEffect, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks'

export const ApprenticeInYearStatistic = () => {
  const apprentices = useAppSelector((state) => state.apprentices)

  const yearChartLabels = [
    t<string>('core.statistic.apprentice_year.not_started'),
    t<string>('core.statistic.apprentice_year.first_year'),
    t<string>('core.statistic.apprentice_year.second_year'),
    t<string>('core.statistic.apprentice_year.third_year'),
    t<string>('core.statistic.apprentice_year.fourth_year'),
    t<string>('core.statistic.apprentice_year.finished'),
    t<string>('core.statistic.apprentice_year.no_contract_information'),
    t<string>('core.statistic.apprentice_year.weird_duration'),
  ]

  const [chart, setChart] = useState({
    labels: yearChartLabels,
    datasets: [
      {
        type: 'doughnut',
        label: t<string>('core.statistic.count'),
        data: [0, 0, 0, 0, 0, 0, 0, 0],
        backgroundColor: ['rgb(135, 136, 138)'],
        hoverBackgroundColor: ['rgb(135, 136, 138)'],
      },
    ],
  })

  useEffect(() => {
    if (apprentices.length <= 0) {
      return
    }

    const today = dayjs()

    let countNotStarted = 0
    let countFirstYear = 0
    let countSecondYear = 0
    let countThirdYear = 0
    let countFourthYear = 0
    let countMoreThanFourthYear = 0
    let countFinishedApprenticeship = 0
    let countNoContractInformation = 0

    apprentices.map((a) => {
      let start = a?.apprentice?.contract_start
      let end = a?.apprentice?.contract_end
      let profession = a?.apprentice?.id_profession
      // information missing for calculation
      if (!start || !end) {
        countNoContractInformation++
      }

      // all needed information available
      else if (start && end && profession) {
        const contractEnd = dayjs(end)
        const contractStart = dayjs(start)

        const diffDaysToStart = today.diff(contractStart, 'day')
        if (diffDaysToStart < 0) {
          // contract has not yet started
          countNotStarted++
        } else {
          // contract has started
          const diffDaysToEnd = today.diff(contractEnd, 'day')
          if (diffDaysToEnd > 0) {
            // contract has finished
            countFinishedApprenticeship++
          } else {
            // contract is ongoing
            const yearDifferenceBetweenTodayAndStart = today.diff(
              contractStart,
              'year'
            )
            switch (yearDifferenceBetweenTodayAndStart) {
              case 0: // first year
                countFirstYear++
                break
              case 1: // second year
                countSecondYear++
                break
              case 2: // third year
                countThirdYear++
                break
              case 3: // fourth year
                countFourthYear++
                break
              default:
                countMoreThanFourthYear++
                console.info(
                  'Apprentice contract information wrong (> 4 years)?'
                )
            }
          }
        }
      }
    })

    setChart({
      labels: yearChartLabels,
      datasets: [
        {
          type: 'doughnut',
          label: t<string>('core.statistic.count'),
          data: [
            countNotStarted,
            countFirstYear,
            countSecondYear,
            countThirdYear,
            countFourthYear,
            countFinishedApprenticeship,
            countNoContractInformation,
            countMoreThanFourthYear,
          ],
          backgroundColor: [
            'rgb(241,241,243)',
            '#c9e0f0',
            'rgb(0, 127, 192)',
            '#006699',
            '#194154',
            'rgb(42,42,42)',
            '#B73328FF',
            '#5d1714',
          ],
          hoverBackgroundColor: [
            'rgb(246,246,246)',
            '#e1eefa',
            'rgb(2,152,229)',
            '#0590d5',
            '#327da1',
            'rgb(103,103,103)',
            '#ef4335',
            '#d3433d',
          ],
        },
      ],
    })
  }, [apprentices])

  return (
    <div className={'col card-hover'}>
      <h4 className={'pb-0 mb-0 statistic-text'}>
        {t<string>('core.statistic.count_apprentices_by_year')} (
        {apprentices.length})
      </h4>
      <div className={'grid justify-content-center align-items-center '}>
        <Chart className={'statistic-chart'} type={'doughnut'} data={chart} />
      </div>
    </div>
  )
}